
import { Subscription, Observable } from 'rxjs';
import { AppState } from '../../core/app-state';
import { Component } from '@angular/core';


@Component({
    selector: 'no-selector',
    template: ''
  })
export class FesBaseComponent {

    static DefaultErrorFn = (e:any) => { console.error(e) } 

    subscriptions : Subscription[] = []

    constructor(public appState : AppState) {
    }
    
    destroy() {
        //console.log('FesBaseComponent.destroy()')
        this.unsubscribe()
    }

    unsubscribe() {
        this.subscriptions.forEach( s => {
            //console.log('removing subscription: ' + s)
            s.unsubscribe()
         } )
    }

    doWhenAppReady( readyFn : ()=>void ) {
        this.subscriptions.push( this.appState.readySubject.subscribe( isReady => { 
            if ( isReady ) {
                readyFn()
            }
        }))
    }

    subscribe<T>( obs : Observable<T>, 
            successFn : (T)=>void, 
            errorFn : (any)=>void = FesBaseComponent.DefaultErrorFn, 
            completeFn : ()=>void = () => {}) {
        const subscription = obs.subscribe(successFn,errorFn,completeFn)
        this.subscriptions.push( subscription)
        return subscription
    }
}